// extracted by mini-css-extract-plugin
export default {"sliderInput":"-sngA___RawSliderInput-module__sliderInput"};